import { useEffect, useState } from "react";
import { isOfMetaOrigin } from "../utils/marketing-url-params.js";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import { actions } from "../store/metaFlightDetails/actions.js";
import { useActions } from "../store/index.js";
import { useClientFetch } from "./useClientFetch.js";
import useGetUrlParams from "./useGetUrlParams.js";
import useTrackFlightsWebUseOfferPos from "./useTrackFlightsWebUseOfferPosExp.js";
import useGetSearchResultsBound from "./useGetSearchResultsBound.js";
import { getSearchResultsFlights, getSelectedInboundFlight } from "../store/searchResults/selectors.js";
import { getSearchResultsFlights as getOBSearchResultsFlights } from "../store/searchResultsBounds/outboundSelectors.js";
import { getSearchResultsFlights as getIBSearchResultsFlights } from "../store/searchResultsBounds/inboundSelectors.js";
import { useSelector } from "react-redux";
import { getFlight } from "../store/flightDetails/selectors.js";
import { getFareOffersWithDetails } from "../store/brandedFareOffers/selectors.js";
export function isBrandedFareOffer(offerToken) {
    const [prefix] = offerToken.split("@");
    return prefix.includes("3904B");
}
const useGetBoundSearchResults = () => {
    const bound = useGetSearchResultsBound();
    const searchResults = useSelector(getSearchResultsFlights);
    const outboundSearchResults = useSelector(getOBSearchResultsFlights);
    const inboundSearchResults = useSelector(getIBSearchResultsFlights);
    if (bound === "outbound") {
        return outboundSearchResults;
    }
    if (bound === "inbound") {
        return inboundSearchResults;
    }
    return searchResults;
};
const useFlightDetailsFromSearchResults = (offerReference) => {
    const [flight, setFlight] = useState(undefined);
    const fullFlightDetails = useSelector(getFlight);
    const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
    const selectedInboundFlight = useSelector(getSelectedInboundFlight);
    const searchResultsFlightsAll = useSelector(getSearchResultsFlights);
    const metaFlightDetailsActions = useActions(actions);
    const flightsWebUseOfferPos = useTrackFlightsWebUseOfferPos();
    const baseOfferToken = useGetUrlParams().getUrlParam("baseOfferToken") || "";
    const searchResultsFlights = useGetBoundSearchResults();
    useEffect(() => {
        if (!flight) {
            setFlight(() => {
                if (isBrandedFareOffer(offerReference) && baseOfferToken && fareOffersWithDetails[baseOfferToken]) {
                    const brandedFares = fareOffersWithDetails[baseOfferToken].brandedFareOffers ?? [];
                    const fare = brandedFares && brandedFares.find((fare) => fare.token == offerReference);
                    if (fare) {
                        const baseOffer = searchResultsFlights.find((flight) => flight.token == baseOfferToken);
                        if (baseOffer) {
                            return { ...baseOffer, ...fare };
                        }
                    }
                }
                return searchResultsFlights.find((flight) => flight.token == offerReference);
            });
        }
    }, [offerReference, fareOffersWithDetails, flight, baseOfferToken, searchResultsFlights]);
    const searchParams = new URLSearchParams();
    if (flightsWebUseOfferPos.isVariant) {
        const salesCountry = getMarketingTrackingVariable("salesCountry");
        salesCountry && searchParams.set("salesCountry", salesCountry);
    }
    const url = `/api/flightFromOfferRelatedFlights/${offerReference}?${searchParams.toString()}`;
    useClientFetch(url, {
        condition: () => {
            const flightFromSearch = selectedInboundFlight
                ? selectedInboundFlight
                : searchResultsFlightsAll.find((flight) => flight.token == offerReference);
            const condition = !flightFromSearch && !fullFlightDetails && isOfMetaOrigin();
            return Boolean(condition);
        },
        fetch: () => {
            metaFlightDetailsActions.fetch();
        },
        success: (uiFlightData) => {
            if (!flight && uiFlightData && Object.keys(uiFlightData).length) {
                metaFlightDetailsActions.fetchSuccess(uiFlightData);
                setFlight(uiFlightData);
            }
        },
        error: (error) => {
            metaFlightDetailsActions.fetchError(error);
        }
    });
    return flight;
};
export default useFlightDetailsFromSearchResults;
